import { Typography } from "@mui/material";
import { useDimensions } from "../hooks";

const Logo = ({
  position = "middle",
  image = "",
}: {
  position?: "middle" | "left";
  image?: string;
}) => {
  const { isSmall } = useDimensions();
  const height = isSmall ? "25px" : "40px";

  return (
    <>
      <Typography
        variant="h6"
        component="div"
        sx={{ flexGrow: 1, textAlign: "center" }}
      >
        <img
          src={image}
          alt="Logo"
          style={{ height, width: "auto", marginRight: 0, paddingTop: 5 }}
        />
      </Typography>
    </>
  );
};

export default Logo;
